import { lazy } from 'react';
import Loadable from 'components/Loadable';
import ModuleTask from 'pages/modules/task/ModuleTask';
import ModulePolicy from 'pages/modules/policy/ModulePolicy';
import ModuleConsole from 'pages/modules/console/ModuleConsole';

const Tree = Loadable(lazy(() => import('pages/Awareness/Tree')));
const Create = Loadable(lazy(() => import('pages/modules/create/Create')));
const ModuleOverview = Loadable(lazy(() => import('pages/modules/ModuleOverview')));
const ModuleInsights = Loadable(lazy(() => import('pages/modules/insights/Insights')));
const ModuleControls = Loadable(lazy(() => import('pages/modules/controls/Controls')));
// const ManageWorkList = Loadable(lazy(() => import('pages/modules/manage/ManageWorkList')));
const ManageWorkList = Loadable(lazy(() => import('pages/modules/manage-new/index')));
const ModuleIdentity = Loadable(lazy(() => import('pages/modules/identity/ModuleIdentity')));
const ModuleStructure = Loadable(lazy(() => import('pages/modules/structure/ModuleStructure')));

const ModuleRoutes = [
	{
		path: 'modules/:module',
		element: <ModuleOverview />,
		children: [
			{ index: true, element: <ModuleInsights /> },
			{ path: 'insights', element: <ModuleInsights /> },
			{ path: 'create', element: <Create /> },
			{ path: 'controls', element: <ModuleControls /> },
			{ path: 'manage', element: <ManageWorkList /> },
			{ path: 'doc-hub/:page', element: <Tree type="module" /> },
			{ path: 'structure', element: <ModuleStructure /> },
			{ path: 'identity', element: <ModuleIdentity /> },
			{ path: 'policy', element: <ModulePolicy /> },
			{ path: 'task', element: <ModuleTask /> },
			{ path: 'console', element: <ModuleConsole /> },
		],
	},
];

export default ModuleRoutes;
